export function loadImage(src, crossOrigin) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        if (crossOrigin) img.crossOrigin = crossOrigin;
        img.onload = () => resolve(img);
        img.onerror = (e) => reject(e);
        img.src = src;
    });
}

function wrapText(ctx, text, x, y, maxWidth, lineHeight) {
    const words = text.split(" ");
    let line = "";
    let currentY = y;

    for (let n = 0; n < words.length; n++) {
        const testLine = line + words[n] + " ";
        const testWidth = ctx.measureText(testLine).width;

        if (testWidth > maxWidth && n > 0) {
            ctx.fillText(line, x, currentY);
            line = words[n] + " ";
            currentY += lineHeight;
        } else {
            line = testLine;
        }
    }
    ctx.fillText(line, x, currentY);
    return currentY + lineHeight;
}

function formatDate(dateString = null) {
    const date = dateString ? new Date(dateString) : new Date();
    const pad = (num) => String(num).padStart(2, "0");
    return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`;
}

function capitalizeWords(str) {
    return str.toLowerCase().split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
}

export async function drawPrescription(ctx, canvas, data, siteLogo) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    try {
        const logo = await loadImage(siteLogo);
        ctx.drawImage(logo, 40, 20, 60, 60);
    } catch (e) {
        console.error("logo load failed:", e);
    }

    ctx.fillStyle = "#000";
    ctx.font = "bold 20px Arial";
    ctx.textAlign = "center";
    ctx.fillText("Dr. AI VATAR", canvas.width / 2, 40);

    ctx.font = "12px Arial";
    ctx.fillText("Email: admin@draivatar.com", canvas.width / 2, 75);

    ctx.beginPath();
    ctx.moveTo(40, 90);
    ctx.lineTo(canvas.width - 40, 90);
    ctx.stroke();

    ctx.textAlign = "left";
    ctx.font = "bold 14px Arial";
    ctx.fillText("Patient Details:", 50, 120);

    ctx.font = "12px Arial";
    ctx.fillText(`Name: ${capitalizeWords(data.patient_name || "-")}`, 70, 140);
    ctx.fillText(`Age: ${data.age || "-"}`, 270, 140);
    ctx.fillText(`DOB: ${formatDate(data.dateOfBirth) || "-"}`, 450, 140);
    ctx.fillText(`Gender: ${capitalizeWords(data.gender || "-")}`, 70, 160);
    ctx.fillText(`Address: ${capitalizeWords(data.address || "-")}`, 270, 160);
    ctx.fillText(`Date: ${formatDate()}`, 450, 35);

    let y = 180;
    y = wrapText(ctx, `Diagnosis: ${data.diagnosis || "-"}`, 70, y, canvas.width - 140, 18);

    ctx.beginPath();
    ctx.moveTo(40, y + 10);
    ctx.lineTo(canvas.width - 40, y + 10);
    ctx.stroke();

    ctx.font = "bold 12px Arial";
    ctx.fillText("Prescribed Medicines:", 50, y + 40);

    let startY = y + 60;
    ctx.font = "12px Arial";

    if (data.medicines?.length) {
        data.medicines.forEach((med, i) => {
            startY = wrapText(ctx, `${i + 1}. ${med.medicine_name}`, 50, startY, canvas.width - 100, 16);
            ctx.fillText(`Dosage: ${med.dosage}   Frequency: ${med.frequency}   Duration: ${med.duration}`, 70, startY);
            startY += 20;
            if (med.instructions) {
                startY = wrapText(ctx, `Instructions: ${med.instructions}`, 70, startY, canvas.width - 140, 16);
            }
            startY += 12;
        });
    } else {
        ctx.fillText("No medicines prescribed", 50, startY);
    }

    const footerY = canvas.height - 90;
    ctx.beginPath();
    ctx.moveTo(40, footerY);
    ctx.lineTo(canvas.width - 40, footerY);
    ctx.stroke();

    ctx.font = "bold 16px Arial";
    ctx.textAlign = "left";
    ctx.fillText(
        `Doctor Name: ${data?.doctor_name?.toLowerCase().startsWith("dr") ? data.doctor_name || "Dr. AI VATAR" : `Dr. ${data?.doctor_name || "AI VATAR"}`}`,
        50, footerY + 50
    );
    ctx.beginPath();
    ctx.moveTo(50, footerY + 54);
    ctx.lineTo(153, footerY + 54);
    ctx.stroke();

    ctx.font = "bold 16px Arial";
    ctx.fillText(`GMC Number: ${data.gmc_no || "-"}`, 50, footerY + 75);
    ctx.beginPath();
    ctx.moveTo(50, footerY + 80);
    ctx.lineTo(158, footerY + 80);
    ctx.stroke();

    if (data.signature) {
        try {
            const signImg = await loadImage(data.signature, "anonymous");
            ctx.drawImage(signImg, canvas.width - 160, footerY + 10, 120, 50);
            ctx.font = "bold 16px Arial";
            ctx.fillText("Signature", canvas.width - 130, footerY + 75);
        } catch (e) {
            console.error("signature load failed:", e);
        }
    }
}